import Configuration from '@/agilis/util/Configuration'
import DataTableV2 from '@/agilis/components/DataTableV2/DataTableV2.vue'
import Title from '@/agilis/components/Title/Title.vue'

export default {
  name: 'CustomerTable',

  components: {
    DataTableV2,
    Title
  },

  data: () => ({
    api: '/api/sales/customer'
  }),

  computed: {

    salesApplicationExists () {
      return Configuration.getApplication('sales')
    },

    configuration () {
      return Configuration.datatable.getDatatable({
        applicationId: 'sales',
        trackerTypeId: 'customer'
      })
    },

    computedTitle () {
      return this.$t('sales.label.customer')
    },

    computedDescription () {
      return this.$t('sales.label.customerDescription')
    }

  },

  methods: {
  }
}
